module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stopped.7e03ffd2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stopped.png
// module id = 3031
// module chunks = 11